@if (overrides) {
  <mds-grid
    [overrides]="overrides"
    [themeClass]="'ag-theme-material'"
    [minHeight]="'100%'"
    [domLayout]="'autoHeight'"
  ></mds-grid>
}


